var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestletter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.493 7.66675H12.5096C9.4763 7.66675 7.66797 9.47508 7.66797 12.5084V19.4834C7.66797 22.5251 9.4763 24.3334 12.5096 24.3334H19.4846C22.518 24.3334 24.3263 22.5251 24.3263 19.4917V12.5084C24.3346 9.47508 22.5263 7.66675 19.493 7.66675Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 14.125H12.875C12.5333 14.125 12.25 13.8417 12.25 13.5C12.25 13.1583 12.5333 12.875 12.875 12.875H19.125C19.4667 12.875 19.75 13.1583 19.75 13.5C19.75 13.8417 19.4667 14.125 19.125 14.125Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.125 19.125H12.875C12.5333 19.125 12.25 18.8417 12.25 18.5C12.25 18.1583 12.5333 17.875 12.875 17.875H19.125C19.4667 17.875 19.75 18.1583 19.75 18.5C19.75 18.8417 19.4667 19.125 19.125 19.125Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestletter);
export default __webpack_public_path__ + "static/media/requestletter.cf91d8e72ee3c8730319c9edcd54b2d4.svg";
export { ForwardRef as ReactComponent };